import { LitElement, html } from '@hh/global.js'

class HHProductCardVariants extends LitElement {
  get anchor() {
    return this.querySelector('.js-anchor')
  }

  get variantButtons() {
    return [...this.querySelectorAll('.js-swatch')]
  }

  connectedCallback() {
    super.connectedCallback()
    this.handleLinkClick()
    this.variantButtons.forEach((button) => {
      button.addEventListener('click', this.onClickHandler.bind(this))
    })

    this.productFormInput = this.closest('hh-product-form')?.querySelector(
      '.js-product-form-input'
    )
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.variantButtons.forEach((button) => {
      button.removeEventListener('click', this.onClickHandler)
    })
  }

  onClickHandler(event) {
    this.anchor.href = event.target.dataset.variantUrl
    this.handleProductFormId(event)
  }

  handleProductFormId(event) {
    if (!this.productFormInput) return
    const variantId = event.target.dataset.variantId

    if (variantId) {
      this.productFormInput.value = variantId
    }
  }

  handleLinkClick() {
    const link = this.querySelector('[data-product-card-link]')

    link?.addEventListener('click', (e) => {
      if (!e.target.closest('a')) return

      const linkHasPageReference = e.target.closest(`[data-page]`)
      if (!linkHasPageReference) return true

      e.preventDefault()

      const updatedURL = new URL(window.location.href)

      if (linkHasPageReference.hasAttribute('id')) {
        updatedURL.hash = linkHasPageReference.getAttribute('id')
      }

      history.pushState({}, '', updatedURL.toString())

      window.location.href = linkHasPageReference.getAttribute('href')
    })
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-card-variants', HHProductCardVariants)
